import { defineStore } from "pinia";
import _ from "lodash";
import * as Flagging from "@/shared/flagging";
import { FeatureFlags, FeatureFlagState, UserTargeting } from "@/shared/types";

const defaultContext: UserTargeting = {
    email: "",
    partnerId: null,
    custodian:  "",
    employerId: null
};

export const initialState: FeatureFlagState = {
    featureFlags: Flagging.defaultFlagState,
    flagsLoaded: false,
    flagsTimedOut: false,
    userContext: defaultContext
};

export const useFeatureFlagStore = defineStore("featureFlag", {
    state: (): FeatureFlagState => (_.cloneDeep(initialState)),
    getters: {
        featureFlagsAvailable: (state): boolean => state.flagsLoaded || state.flagsTimedOut,
        flags: (state): FeatureFlags => {
            return { ...state.featureFlags };
        },
        context: state => state.userContext
    },
    actions: {
        setFlags (flags: Record<string, boolean>) {
            this.featureFlags = flags;
            this.flagsLoaded = true;
            this.flagsTimedOut = false;
        },
        updateFlag (flag: string, value: boolean) {
            this.featureFlags[flag] = value;
        },
        setTimedOut () {
            this.flagsTimedOut = true;
        },
        setUserContext (context: UserTargeting) {
            if (context === null && !_.isEqual(defaultContext, this.userContext)) {
                this.userContext = defaultContext;
                return;
            }

            const newContext = { ... this.userContext, ... context };
            if (!_.isEqual(newContext, this.userContext)) {
                this.userContext = newContext;
            }
        }
    }
});